module.exports = __webpack_public_path__ + "static/media/logo-bca.93216d97.jpg";